// extracted by mini-css-extract-plugin
module.exports = {"header":"PromotionHeader_header__EVpCs","headerLogo":"PromotionHeader_headerLogo__10JOY"};